import { Button, Chip, Grid2, MenuItem, Select, Snackbar, Switch, TextField, Typography } from "@mui/material";
import TokenError from "../tokenError";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Label } from "flowbite-react";
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import { DateTimePicker, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo/DemoContainer.js";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Modal, Box } from '@mui/material';
import {CustomSwitch} from '../ui/Toggle.jsx';

const CitySettings = () => {
    const navigate = useNavigate();
    const cities = JSON.parse(localStorage.getItem('cities'));
    const is_operational_hours_enabled = localStorage.getItem('is_operational_hours_enabled');
    const is_offering_type_enabled = localStorage.getItem('is_offering_type_enabled');

    const [tokenExpired, setTokenExpired] = useState(false);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [cityFilter, setCityFilter] = useState(cities[0].city_id);

    const [customerSupportNo, setCustomerSupportNo] = useState('');
    const [driverSupportNo, setDriverSupportNo] = useState('');
    const [emergencyNo, setEmergencyNo] = useState('');
    const [supportEmail, setSupportEmail] = useState('');
    const [serviceType, setServiceType] = useState('');
    const [roundingFareFactor, setRoundingFareFactor] = useState('');
    const [customerFareFactor, setCustomerFareFactor] = useState('');
    const [operationalStartTime, setOperationalStartTime] = useState(null);
    const [operationalEndTime, setOperationalEndTime] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [pendingTimeChange, setPendingTimeChange] = useState(null);
    const [enableOperationalHour, setEnableOperationalHour] = useState(1);
    const [initialValues, setInitialValues] = useState(null);

    const [packageGuidelines, setPackageGuidelines] = useState('');
    const [callMasking, setCallMasking] = useState(false);
    const [prohibitedItems, setProhibitedItems] = useState('');
    const [packageGuidelinesArr, setPackageGuidelinesArr] = useState([]);
    const [prohibitedItemsArr, setProhibitedItemsArr] = useState([]);
    const [driverDebtLimit, setDriverDebtLimit] = useState('');
    const [offeringType, setOfferingType] = useState();
    const is_customer_fare_factor_enabled = localStorage.getItem('is_customer_fare_factor_enabled');
    const call_masking_enabled = localStorage.getItem('call_masking_enabled');
    const is_driver_debt_limit_enabled = localStorage.getItem('is_driver_debt_limit_enabled') || 0;

    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }

    const fetchCitySettings = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/settings/client_city_info';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                const fetchedData = response.data[0];
                setCustomerSupportNo(fetchedData.customer_support_no);
                setDriverSupportNo(fetchedData.driver_support_no);
                setEmergencyNo(fetchedData.emergency_no);
                setSupportEmail(fetchedData.support_email);
                setServiceType(fetchedData.service_type);
                setOfferingType(fetchedData.offering_type);
                setRoundingFareFactor(fetchedData.customer_fare_factor_rounding);
                setCustomerFareFactor(fetchedData.customer_fare_factor);
                setCallMasking(fetchedData.call_masking_enabled == 1 ? true : false);
                setDriverDebtLimit(fetchedData.driver_debt_limit);
                setEnableOperationalHour(fetchedData.operational_end_time !== null ? 1 : 0);
                
                // Store initial values for comparison
                setInitialValues({
                    customer_support_no: fetchedData.customer_support_no,
                    driver_support_no: fetchedData.driver_support_no,
                    emergency_no: fetchedData.emergency_no,
                    support_email: fetchedData.support_email,
                    service_type: fetchedData.service_type,
                    operational_start_time: fetchedData.operational_start_time,
                    operational_end_time: fetchedData.operational_end_time,
                    enable_operational_hour: fetchedData.operational_end_time !== null ? 1 : 0,
                    offering_type: fetchedData.offering_type,
                    packageGuidelinesArr: fetchedData?.offering_type?.[3]?.package_guide_line || [],
                    prohibitedItemsArr: fetchedData?.offering_type?.[3]?.prohibited_items || [],
                    callMasking: fetchedData.call_masking_enabled,
                    packageGuidelinesArr: fetchedData?.offering_type?.[3]?.package_guide_line || [],
                    prohibitedItemsArr: fetchedData?.offering_type?.[3]?.prohibited_items || [],
                    driver_debt_limit: fetchedData.driver_debt_limit
                });
                if (fetchedData.operational_start_time) {
                    const [hours, minutes] = fetchedData.operational_start_time.split(':');
                    setOperationalStartTime(dayjs().hour(hours).minute(minutes));
                }
                if (fetchedData.operational_end_time) {
                    const [hours, minutes] = fetchedData.operational_end_time.split(':');
                    setOperationalEndTime(dayjs().hour(hours).minute(minutes));
                }
                else{
                    setEnableOperationalHour(0);
                }
                if(Number(is_offering_type_enabled)){
                    setPackageGuidelinesArr(fetchedData?.offering_type?.[3]?.package_guide_line || []);
                    setProhibitedItemsArr(fetchedData?.offering_type?.[3]?.prohibited_items || []);
                }
                if(call_masking_enabled){
                    setCallMasking(fetchedData.call_masking_enabled == 1 ? true:false);
                }
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        fetchCitySettings();
    }, [cityFilter])


    const handleConfirmTimeChange = (confirmed) => {
        setShowConfirmModal(false);
        if (confirmed && pendingTimeChange) {
            if (pendingTimeChange.isReset) {
                setEnableOperationalHour(pendingTimeChange.newValue);
                if (!pendingTimeChange.newValue) {
                    // Only clear times when disabling
                    setOperationalStartTime(null);
                    setOperationalEndTime(null);
                }
            } else if (pendingTimeChange.isStartTime) {
                setOperationalStartTime(pendingTimeChange.newValue);
            } else {
                setOperationalEndTime(pendingTimeChange.newValue);
            }
        } else if (pendingTimeChange?.isReset) {
            // If cancelled, revert to previous state
            setEnableOperationalHour(!pendingTimeChange.newValue);
        }
        setPendingTimeChange(null);
    };

    const saveData = async () => {

        // Check if any field has been modified
        if (initialValues) {
            const currentValues = {
                customer_support_no: customerSupportNo,
                driver_support_no: driverSupportNo,
                emergency_no: emergencyNo,
                support_email: supportEmail,
                customer_fare_factor_rounding: roundingFareFactor,
                customer_fare_factor: customerFareFactor,
                service_type: serviceType,
                operational_start_time: operationalStartTime ? operationalStartTime.format('HH:mm') : null,
                operational_end_time: operationalEndTime ? operationalEndTime.format('HH:mm') : null,
                enable_operational_hour: enableOperationalHour,
                packageGuidelinesArr: packageGuidelinesArr,
                prohibitedItemsArr: prohibitedItemsArr,
                driver_debt_limit: driverDebtLimit
            };

            const hasChanges = Object.keys(currentValues).some(key => {
                // Special handling for operational hours
                if (key === 'enable_operational_hour') {
                    return currentValues[key] !== initialValues[key];
                }
                // Special handling for arrays - compare length and content
                if (key === 'packageGuidelinesArr' || key === 'prohibitedItemsArr') {
                    const current = currentValues[key] || [];
                    const initial = initialValues[key] || [];
                    if (current.length !== initial.length) return true;
                    return current.some((item, index) => item !== initial[index]);
                }
                if (key === 'customer_fare_factor_rounding' || key === 'customer_fare_factor') {
                    return currentValues[key] !== initialValues[key];
                }
                return currentValues[key] !== initialValues[key];
            });

            if (!hasChanges) {
                setMessage('No changes to update.');
                showSnackbar(true);
                return;
            }
        }

        if(is_offering_type_enabled == 1 && packageGuidelinesArr.length==0){
            setMessage('Please add atleast one package guideline');
            showSnackbar(true);
            return;
        }
        if(is_offering_type_enabled == 1 && prohibitedItemsArr.length==0){
            setMessage('Please add atleast one prohibited item');
            showSnackbar(true);
            return;
        }

        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            customer_support_no: customerSupportNo,
            driver_support_no: driverSupportNo,
            emergency_no: emergencyNo,
            support_email: supportEmail,
            city_id: cityFilter,
            service_type: serviceType
        };
        if(call_masking_enabled == 1){
            payload.call_masking_enabled = callMasking ? 1 : 0;
        }
        if(Number(is_customer_fare_factor_enabled)){
            payload.customer_fare_factor_rounding = roundingFareFactor;
            payload.customer_fare_factor = customerFareFactor;
        }
        if(Number(is_operational_hours_enabled)){
            if(enableOperationalHour){
                if(operationalStartTime){
                    payload.operational_start_time = (operationalStartTime).format('HH:mm');
                }
                if(operationalEndTime){
                    payload.operational_end_time = (operationalEndTime).format('HH:mm');
                }
            }
            if(!enableOperationalHour){
                payload.operational_start_time = null;
                payload.operational_end_time = null;
            }
        }
        if(Number(is_offering_type_enabled)){
            offeringType[3].package_guide_line = packageGuidelinesArr;
            offeringType[3].prohibited_items = prohibitedItemsArr;
            payload.offering_type = offeringType;
        }
        if(Number(is_driver_debt_limit_enabled)){
            payload.driver_debt_limit = driverDebtLimit;
        }

        try {
            const url = operationsUrl + '/settings/client_city_info';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                fetchCitySettings();
            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
            else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        showSnackbar(false);
    };

    const handleResetTime = (val) => {
        // setPendingTimeChange({ 
        //     isReset: true, 
        //     newValue: val
        // });
        // setShowConfirmModal(true);

        if (!val && (operationalStartTime || operationalEndTime)) {
            setPendingTimeChange({ 
                isReset: true, 
                newValue: val
            });
            setShowConfirmModal(true);
        } else {
            setEnableOperationalHour(val);
        }
    }

    return(
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                City Settings
            </Typography>

            <Grid2 item sx={{marginTop:'2%'}}>
                <Select value={cityFilter} onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                style={{width: '220px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                    <MenuItem value="">Select City</MenuItem>
                    {cities.map((city) => (
                        <MenuItem key={city.city_name} value={city.city_id}>
                            {city.city_name}
                        </MenuItem>
                    ))}
                </Select>
            </Grid2>

            <Grid2 sx={{margin:"4px", backgroundColor:"#fff", borderRadius:'8px', padding:'12px', marginTop:'12px'}}>

                <Typography sx={{color:'#4E545D', fontSize:'20px'}}> City Settings</Typography>

                <Grid2 item container sx={{marginTop:'24px'}} spacing={4} size={12}>
                    <Grid2 item size={6}>
                        <Label>Customer Support Number<span style={{ color: 'red' }}>*</span></Label>
                        <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                            placeholder="Customer Support Number" fullWidth variant="outlined" type="text"
                            value={customerSupportNo}
                            onChange={(e) => setCustomerSupportNo(e.target.value)}
                            InputProps={{
                                inputProps: { min: 0 },
                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                            }}
                        />
                    </Grid2>

                    <Grid2 item size={6}>
                        <Label>Driver Support Number<span style={{ color: 'red' }}>*</span></Label>
                        <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                            placeholder="Driver Support Number" fullWidth variant="outlined" type="text"
                            value={driverSupportNo}
                            onChange={(e) => setDriverSupportNo(e.target.value)}
                            InputProps={{
                                inputProps: { min: 0 },
                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                            }}
                        />
                    </Grid2>
                </Grid2>

                <Grid2 item container sx={{marginTop:'24px'}} spacing={4} size={12}>
                    <Grid2 item size={6}>
                        <Label>Emergency Number<span style={{ color: 'red' }}>*</span></Label>
                        <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                            placeholder="Emergency Number" fullWidth variant="outlined" type="text"
                            value={emergencyNo}
                            onChange={(e) => setEmergencyNo(e.target.value)}
                            InputProps={{
                                inputProps: { min: 0 },
                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                            }}
                        />
                    </Grid2>

                    <Grid2 item size={6}>
                        <Label>Service Type<span style={{ color: 'red' }}>*</span></Label>
                        <Select  sx={{marginTop:'2%', color:'#1A1E25', height:'50px'}}
                            fullWidth
                            value={serviceType}
                            onChange={(e) => setServiceType(e.target.value)}
                        >
                            <MenuItem value="1">On-Demand</MenuItem>
                            <MenuItem value="2">Scheduled</MenuItem>
                            <MenuItem value="3">On-Demand and Scheduled</MenuItem>
                        </Select>
                    </Grid2>

                    {is_customer_fare_factor_enabled == 1 && <Grid2 item size={6}>
                        <Label>Rounding Fare Factor<span style={{ color: 'red' }}>*</span></Label>
                        <Select  sx={{marginTop:'2%', color:'#1A1E25', height:'50px'}}
                            fullWidth
                            value={roundingFareFactor}
                            onChange={(e) => setRoundingFareFactor(e.target.value)}
                        >   
                            <MenuItem value="0">Disable</MenuItem>
                            <MenuItem value="1">Cieling</MenuItem>
                            <MenuItem value="2">Floor</MenuItem>
                        </Select>
                    </Grid2>}

                    {is_customer_fare_factor_enabled == 1 && <Grid2 item size={6}>
                        <Label>Customer Fare Factor<span style={{ color: 'red' }}>*</span></Label>
                        <Select  sx={{marginTop:'2%', color:'#1A1E25', height:'50px'}}
                            fullWidth
                            value={customerFareFactor}
                            onChange={(e) => setCustomerFareFactor(e.target.value)}
                        >
                            <MenuItem value="0">Disable</MenuItem>
                            <MenuItem value="5">5</MenuItem>
                            <MenuItem value="50">50</MenuItem>
                            <MenuItem value="500">500</MenuItem>
                            <MenuItem value="5000">5000</MenuItem>
                            <MenuItem value="50000">50000</MenuItem>
                            <MenuItem value="500000">500000</MenuItem>
                            <MenuItem value="5000000">5000000</MenuItem>
                            <MenuItem value="50000000">50000000</MenuItem>
                            <MenuItem value="500000000">500000000</MenuItem>
                        </Select>
                    </Grid2>}

                    {/* Driver Debt Limit */}
                    {is_driver_debt_limit_enabled == 1 && 
                        <Grid2 item size={6}>
                            <Label>Driver Minimum Wallet Balance<span style={{ color: 'red' }}>*</span></Label>
                            <TextField
                                sx={{marginTop:'2%', color:'#1A1E25', height:'50px'}}
                                fullWidth
                                value={driverDebtLimit}
                                type="number"
                                onChange={(e) => {
                                    const value = e.target.value;

                                    // Allow negative numbers with max 2 decimal places
                                    if (/^-?\d*\.?\d{0,2}$/.test(value)) {
                                        setDriverDebtLimit(value);
                                    }
                                }}
                            />
                        </Grid2>
                    }

                    {!!Number(is_operational_hours_enabled) && 
                        <Grid2 size={12} sx={{border:'1px solid #D1D5DB', borderRadius:'8px', padding:'16px'}}>
                            <Grid2 sx={{display:'flex', alignItems:'center'}}>
                                <Typography>Enable/Disable Operational Hours:</Typography>
                                <Switch 
                                checked={enableOperationalHour} 
                                onChange={(e) => handleResetTime(e.target.checked)}
                                inputProps={{ 'aria-label': 'Enable/Disable Operational Hours' }}
                            />
                            </Grid2>

                            {(!!enableOperationalHour) && 
                                <>
                                    <hr style={{border: 'none', borderTop: '1px solid #D1D5DB'}} />
                                    <Grid2 container spacing={4}>
                                        <Grid2 item size={6}>
                                            <Label>Operational Start Time<span style={{ color: 'red' }}>*</span></Label>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DemoContainer components={['DatePicker']} sx={{ '& .MuiStack-root': { padding: 0, width: '100%' } }}>
                                                    <TimePicker
                                                        value={ operationalStartTime}
                                                        disabled={!enableOperationalHour}
                                                        onChange={(newValue) => {
                                                            setOperationalStartTime(newValue);
                                                        }}
                                                        sx={{
                                                            width: '100%',
                                                            '& .MuiOutlinedInput-root': { height: '48px', backgroundColor: '#FFFFFF', border: 'none' },
                                                            '& .MuiInputBase-input': { fontSize: '16px', padding: '0px 14px', color:'inherit' },
                                                        }}
                                                        slotProps={{ textField: { fullWidth: true, placeholder: 'Select time' } }}
                                                    />
                                                </DemoContainer>
                                            </LocalizationProvider>
                                        </Grid2>

                                        <Grid2 item size={6}>
                                            <Label>Operational End Time<span style={{ color: 'red' }}>*</span></Label>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DemoContainer components={['DatePicker']} sx={{ '& .MuiStack-root': { padding: 0, width: '100%' } }}>
                                                    <TimePicker
                                                        value={ operationalEndTime}
                                                        disabled={!enableOperationalHour}
                                                        onChange={(newValue) => {
                                                            setOperationalEndTime(newValue);
                                                        }}
                                                        sx={{
                                                            width: '100%',
                                                            '& .MuiOutlinedInput-root': { height: '48px', backgroundColor: '#FFFFFF', border: 'none' },
                                                            '& .MuiInputBase-input': { fontSize: '16px', padding: '0px 14px', color:'inherit' },
                                                        }}
                                                        slotProps={{ textField: { fullWidth: true, placeholder: 'Select time' } }}
                                                    />
                                                </DemoContainer>
                                            </LocalizationProvider>
                                        </Grid2>
                                    </Grid2>
                                </>
                            }
                        </Grid2>
                    }
                    

                    {/* <Grid2 item size={6}>
                        <Label>Support Email<span style={{ color: 'red' }}>*</span></Label>
                        <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                            placeholder="Support Email" fullWidth variant="outlined" type="text" 
                            value={supportEmail}
                            onChange={(e) => setSupportEmail(e.target.value)}
                            InputProps={{
                                inputProps: { min: 0 },
                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                            }}
                        />
                    </Grid2> */}
                </Grid2>

                {is_offering_type_enabled == 1 &&
                    <Grid2 container spacing={4} sx={{border:'1px solid #E3E5E8', borderRadius:'8px', padding:'12px', mt:'2%'}}>
                        <Grid2 item size={6}>
                            <Label> Package Guidelines<span style={{ color: 'red' }}>*</span></Label>
                            <Grid2 sx={{display:'flex', flexDirection: 'column', gap: '10px'}}>
                                <Grid2 sx={{display:'flex', gap:'2%'}}>
                                    <TextField
                                        sx={{marginTop:'2%', color:'#1A1E25'}}
                                        placeholder="Package Guidelines" 
                                        fullWidth 
                                        variant="outlined" 
                                        type="text" 
                                        value={packageGuidelines}
                                        onChange={(e) => setPackageGuidelines(e.target.value)}
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter' && packageGuidelines.trim()) {
                                                setPackageGuidelinesArr([...packageGuidelinesArr, packageGuidelines.trim()]);
                                                setPackageGuidelines('');
                                            }
                                        }}
                                        InputProps={{
                                            style: {height: '50px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#FFFFFF'}
                                        }}
                                    />
                                    <Button 
                                        onClick={() => {
                                            if (packageGuidelines.trim()) {
                                                setPackageGuidelinesArr([...packageGuidelinesArr, packageGuidelines.trim()]);
                                                setPackageGuidelines('');
                                            }
                                        }}
                                        sx={{
                                            marginTop:'2%', 
                                            color:'#1A1E25', 
                                            backgroundColor:'#E3E5E8', 
                                            height:'50px', 
                                            width:'50px',
                                            '&:hover': {
                                                backgroundColor: '#d0d2d5'
                                            }
                                        }}
                                    >
                                        +
                                    </Button>
                                </Grid2>
                                
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px', mt: 1 }}>
                                    {packageGuidelinesArr.map((item, index) => (
                                        <Chip
                                            key={index}
                                            label={item}
                                            onDelete={() => {
                                                const newArr = [...packageGuidelinesArr];
                                                newArr.splice(index, 1);
                                                setPackageGuidelinesArr(newArr);
                                            }}
                                            sx={{
                                                backgroundColor: '#E3E5E8',
                                                borderRadius: '4px',
                                                maxWidth: '100%',
                                                height: 'auto',
                                                whiteSpace: 'pre-wrap',
                                                '& .MuiChip-label': {
                                                    display: 'block',
                                                    whiteSpace: 'normal',
                                                    overflow: 'visible',
                                                    textOverflow: 'clip',
                                                    padding: '4px 8px',
                                                    wordBreak: 'break-word'
                                                },
                                                '& .MuiChip-deleteIcon': {
                                                    color: '#6B7280',
                                                    '&:hover': {
                                                        color: '#EF4444'
                                                    }
                                                }
                                            }}
                                        />
                                    ))}
                                </Box>
                            </Grid2>
                            
                        </Grid2>

                        <Grid2 item size={6}>
                            <Label> Prohibited Items<span style={{ color: 'red' }}>*</span></Label>
                            <Grid2 sx={{display:'flex', flexDirection: 'column', gap: '10px'}}>
                                <Grid2 sx={{display:'flex', gap:'2%'}}>
                                    <TextField
                                        sx={{marginTop:'2%', color:'#1A1E25'}}
                                        placeholder="Prohibited Items" 
                                        fullWidth 
                                        variant="outlined" 
                                        type="text" 
                                        value={prohibitedItems}
                                        onChange={(e) => setProhibitedItems(e.target.value)}
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter' && prohibitedItems.trim()) {
                                                setProhibitedItemsArr([...prohibitedItemsArr, prohibitedItems.trim()]);
                                                setProhibitedItems('');
                                            }
                                        }}
                                        InputProps={{
                                            style: {height: '50px', fontSize: '16px', padding: '8px 14px', backgroundColor: '#FFFFFF'}
                                        }}
                                    />
                                    <Button 
                                        onClick={() => {
                                            if (prohibitedItems.trim()) {
                                                setProhibitedItemsArr([...prohibitedItemsArr, prohibitedItems.trim()]);
                                                setProhibitedItems('');
                                            }
                                        }}
                                        sx={{
                                            marginTop:'2%', 
                                            color:'#1A1E25', 
                                            backgroundColor:'#E3E5E8', 
                                            height:'50px', 
                                            width:'50px',
                                            '&:hover': {
                                                backgroundColor: '#d0d2d5'
                                            }
                                        }}
                                    >
                                        +
                                    </Button>
                                </Grid2>
                                
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>
                                    {prohibitedItemsArr.map((item, index) => (
                                        <Chip
                                            key={index}
                                            label={item}
                                            onDelete={() => {
                                                const newArr = [...prohibitedItemsArr];
                                                newArr.splice(index, 1);
                                                setProhibitedItemsArr(newArr);
                                            }}
                                            sx={{
                                                backgroundColor: '#E3E5E8',
                                                borderRadius: '4px',
                                                '& .MuiChip-deleteIcon': {
                                                    color: '#6B7280',
                                                    '&:hover': {
                                                        color: '#EF4444'
                                                    }
                                                }
                                            }}
                                        />
                                    ))}
                                </div>
                            </Grid2>
                        </Grid2>
                        
                    </Grid2>
                }

                { call_masking_enabled == 1 &&
                    <Grid2 spacing={4} sx={{border:'1px solid #E3E5E8', borderRadius:'8px', padding:'12px', mt:'2%', width:'50%'}}>
                        <Typography 
                            variant="h6" 
                            sx={{ 
                                marginBottom: '16px', 
                                color: '#2C3E50', 
                                fontWeight: 600,
                                fontSize: '18px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                        >
                            <span style={{ 
                                display: 'inline-flex', 
                                alignItems: 'center', 
                                gap: '8px' 
                            }}>
                                📞 Call Masking
                            </span>
                        </Typography>
                        <Typography 
                            variant="body2" 
                            sx={{ 
                                marginBottom: '16px', 
                                color: '#6B7280', 
                                fontSize: '14px',
                                fontWeight: 400,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                justifyContent: 'space-between'
                            }}
                        >
                            Control the visibility of phone numbers in customer calls and driver calls
                        <CustomSwitch 
                            checked={callMasking}
                            backgroundtheme={callMasking ? "#0065FF" : "#8ffabc"}
                            onChange={(e) => setCallMasking(e.target.checked)}
                            />
                        </Typography>
                    </Grid2>
                }

                <Grid2 item sx={{marginTop:'4%', alignItems:'center', justifyContent:'center', display:'flex', marginBottom:'20px'}} size={12}>
                    <Button
                        onClick={saveData}
                        variant="contained">Update</Button>
                </Grid2>

            </Grid2>

            <Modal
                open={showConfirmModal}
                onClose={() => handleConfirmTimeChange(false)}
                aria-labelledby="confirm-time-change-modal"
                aria-describedby="confirm-time-change-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 1
                }}>
                    <Typography id="confirm-time-change-modal" variant="h6" component="h2" gutterBottom>
                        Confirm Time Change
                    </Typography>
                    <Typography id="confirm-time-change-description" sx={{ mb: 2 }}>
                        Changing the operational hours may affect availability. Do you want to continue?
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 }}>
                        <Button variant="outlined" onClick={() => handleConfirmTimeChange(false)}>
                            No
                        </Button>
                        <Button variant="contained" onClick={() => handleConfirmTimeChange(true)}>
                            Yes
                        </Button>
                    </Box>
                </Box>
            </Modal>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>

        </div>
    )
}

export default CitySettings;